import React from "react";
import { Link } from "react-router-dom";
import { FiMapPin, FiPhone, FiMail, FiArrowUpRight } from "react-icons/fi";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaLinkedinIn,
} from "react-icons/fa";
import { useSiteSettings } from "../../context/SiteSettingsContext";
import { getImageUrl } from "../../utils/helpers";
import "./Footer.css";

const Footer = () => {
  const { settings } = useSiteSettings();

  const phone = settings.contact_phone || "+91 76766 31464";
  const email = settings.contact_email || "info@ptes.edu.in";
  const address = settings.contact_address || "Belagavi, Karnataka, India";
  const applyLink = settings.apply_now_link || "/contact";
  const footerText =
    settings.footer_text ||
    `© ${new Date().getFullYear()} PeopleTree Education Society, Belagavi. All Rights Reserved.`;

  const socials = [
    { key: "social_facebook", icon: <FaFacebookF />, label: "Facebook" },
    { key: "social_instagram", icon: <FaInstagram />, label: "Instagram" },
    { key: "social_twitter", icon: <FaTwitter />, label: "Twitter" },
    { key: "social_linkedin", icon: <FaLinkedinIn />, label: "LinkedIn" },
  ];

  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="container">
          <div className="footer__cta">
            <div>
              <h2 className="footer__cta-title">Ready to Shape Your Future?</h2>
              <p className="footer__cta-text">
                We Inspire Students Not What to Think Rather How to Think and How to Make Things Happen!
              </p>
            </div>
            {applyLink.startsWith("http") ? (
              <a
                href={applyLink}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn--secondary btn--lg"
              >
                Apply Now <FiArrowUpRight />
              </a>
            ) : (
              <Link to={applyLink} className="btn btn--secondary btn--lg">
                Apply Now <FiArrowUpRight />
              </Link>
            )}
          </div>
        </div>
      </div>

      <div className="footer__main">
        <div className="container footer__grid">
          <div className="footer__col">
            <div className="footer__brand">
              {settings.site_logo ? (
                <img loading="lazy" decoding="async"
                  src={getImageUrl(settings.site_logo)}
                  alt={settings.site_name || "PeopleTree"}
                  className="footer__brand-logo"
                />
              ) : (
                <>
                  <span className="footer__brand-name">
                    {settings.site_name || "PeopleTree"}
                  </span>
                  <span className="footer__brand-sub">
                    {settings.site_tagline || "Growing Intellects"}
                  </span>
                </>
              )}
            </div>
            <p className="footer__desc">
              Empowering students with quality education, practical skills, and
              a nurturing environment to succeed in the global landscape.
            </p>
            <div className="footer__socials">
              {socials.map((s) =>
                settings[s.key] ? (
                  <a
                    key={s.key}
                    href={settings[s.key]}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer__social"
                    aria-label={s.label}
                  >
                    {s.icon}
                  </a>
                ) : (
                  <span
                    key={s.key}
                    className="footer__social footer__social--disabled"
                    aria-label={s.label}
                  >
                    {s.icon}
                  </span>
                ),
              )}
            </div>
          </div>

          <div className="footer__col">
            <h4 className="footer__col-title">Quick Links</h4>
            <nav className="footer__links">
              <Link to="/about">About Us</Link>
              <Link to="/courses">Courses</Link>
              <Link to="/life">Campus Life</Link>
              <Link to="/life/gallery">Gallery</Link>
              <Link to="/wings">Wings</Link>
              <Link to="/library">Library</Link>
              <Link to="/contact">Contact Us</Link>
            </nav>
          </div>

          <div className="footer__col">
            <h4 className="footer__col-title">Our Courses</h4>
            <nav className="footer__links">
              <Link to="/courses/bba">BBA</Link>
              <Link to="/courses/bca">BCA</Link>
              <Link to="/courses/pu-commerce">PU Commerce</Link>
            </nav>
          </div>

          <div className="footer__col">
            <h4 className="footer__col-title">Contact Us</h4>
            <div className="footer__contact">
              <div className="footer__contact-item">
                <FiMapPin className="footer__contact-icon" />
                <span>{address}</span>
              </div>
              <div className="footer__contact-item">
                <FiPhone className="footer__contact-icon" />
                <a href={`tel:${phone.replace(/\s/g, "")}`}>{phone}</a>
              </div>
              <div className="footer__contact-item">
                <FiMail className="footer__contact-icon" />
                <a href={`mailto:${email}`}>{email}</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <p>{footerText}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
